import { API_BASE_URL } from '@src/runtimeConfig'
/* eslint-disable import/prefer-default-export */
import { get, getCookie } from '@src/services/NetworkUtils'

const baseURL = API_BASE_URL

// Build an audit-trail export URL with our full set of filter params
// (the shared `download()` helper whitelists a fixed param set that
// doesn't include module / event_code / outcome / platform / date_from /
// date_to). The backend `auth` middleware accepts ?token=<jwt> as an
// alternative to the Authorization header, so window.open works.
function buildExportUrl(params = {}) {
  const url = new URL(`${baseURL}/v1/audit-trail/export`)
  url.searchParams.set('token', getCookie('token-backoffice'))
  const passthrough = [
    'search', 'module', 'event_code', 'actor_id', 'outcome', 'platform',
    'date_from', 'date_to', 'sort', 'order',
  ]
  for (const key of passthrough) {
    const value = params[key]
    if (value != null && value !== '') url.searchParams.set(key, value)
  }
  // filter[] array (MyFilterModal) — serialize each entry with bracket notation
  if (Array.isArray(params.filter)) {
    params.filter.forEach((entry, i) => {
      const flatten = (obj, prefix) => {
        for (const [k, v] of Object.entries(obj || {})) {
          if (v == null) continue
          const path = `${prefix}[${k}]`
          if (typeof v === 'object' && !Array.isArray(v)) flatten(v, path)
          else url.searchParams.set(path, v)
        }
      }
      flatten(entry, `filter[${i}]`)
    })
  }
  return url.toString()
}

export const AuditTrailService = {
  getAuditTrail: async (params) => await get('/v1/audit-trail', params),
  exportAuditTrail: (params) => buildExportUrl(params),
  getModuleOptions: async () => await get('/v1/option/audit-trail-modules'),
  getEventOptions: async (params) => await get('/v1/option/audit-trail-events', params),
  getOutcomeOptions: async () => await get('/v1/option/audit-trail-outcomes'),
  getPlatformOptions: async () => await get('/v1/option/audit-trail-platforms'),
}
